export default __webpack_public_path__ + "5982c23c62aea06a9fa0cc9300207e07.png";